import React, { useCallback, useState } from 'react';
import { clsb, clsx } from 'js/utils/classNames.util';
import { Icon } from 'js/components/common/Icon';

import style from './Suggestions.scss';

export const Suggestions: React.FC<{
    suggestionsRef: React.RefObject<HTMLSelectElement>;
    suggestions: { label: string; value: string }[];
} & React.SelectHTMLAttributes<HTMLSelectElement>> = ({
    className,
    id,
    suggestionsRef,
    onChange,
    suggestions
}) => {
    const [isSuggestionsSelectFocused, setSuggestionsSelectFocused] = useState(false);

    const onKeyUp = useCallback((event: React.KeyboardEvent<HTMLElement>) => {
        if (event.key === 'Tab') {
            setSuggestionsSelectFocused(true);
        }
    }, []);
    const onBlur = useCallback(() => {
        setSuggestionsSelectFocused(false);
    }, []);

    return (
        <div className={clsx([clsb([style], ['container']), className, isSuggestionsSelectFocused && style.focus])}>
            <label htmlFor={id}>
                <select
                    aria-label={'suggestions'}
                    defaultValue=""
                    id={id}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyUp={onKeyUp}
                    ref={suggestionsRef}
                >
                    <option value="" disabled className={style.emptyOption} />
                    {suggestions?.map(item => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                    ))}
                </select>
                <div className={style.dropDownWrap}>
                    <Icon
                        type="arrowDropdown"
                        className={style.dropDownIcon}
                    />
                </div>
            </label>
        </div>
    );
};
